import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const addQuery = async (questionData) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.askAQueryApi, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    payload: questionData,
  });
  return data;
};

const AskAnExpertService = { addQuery };
export default AskAnExpertService;
